import {
  SHOW_RAW_DATA_MODAL,
  SHOW_RAW_DATA_MODAL_HIDE
} from 'Redux/actionTypes';

export const showRawDataModal = () => ({
  type: SHOW_RAW_DATA_MODAL,
  payload: {  }
});

export const showRawDataModalHide = () => ({
  type: SHOW_RAW_DATA_MODAL_HIDE,
  payload: {}
});